import { Phone, MapPin, MessageCircle, Mail } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { ConsultNotice } from "@/components/ConsultNotice";
import { ConsultForm } from "@/components/ConsultForm";
import { waFor } from "@/components/FloatingWhatsApp";
import { CONTACT } from "@/lib/api";
import { track } from "@/lib/analytics";

export const ContactDetails = () => (
  <div className="space-y-4 text-sm">
    <p className="text-white" data-testid="contact-founder"><span className="text-slate-400">Founder:</span> {CONTACT.founder}</p>
    <a href={CONTACT.phoneHref} data-testid="contact-phone-link" className="flex items-center gap-3 text-white hover:text-[#00F0FF]"><Phone className="h-4 w-4 text-[#00F0FF]" />Mobile / Helpline: +91 {CONTACT.phone}</a>
    <a href={waFor()} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { location: "contact_section" })} data-testid="contact-whatsapp-link" className="flex items-center gap-3 text-white hover:text-[#00F0FF]"><MessageCircle className="h-4 w-4 text-[#00F0FF]" />Chat on WhatsApp</a>
    <a href={CONTACT.mailHref} data-testid="contact-email-link" className="flex items-center gap-3 break-all text-white hover:text-[#00F0FF]"><Mail className="h-4 w-4 shrink-0 text-[#00F0FF]" />{CONTACT.email}</a>
    <p className="flex items-center gap-3 text-slate-300"><MapPin className="h-4 w-4 shrink-0 text-[#00F0FF]" />{CONTACT.location}</p>
  </div>
);

export const ConsultSection = ({ preset }) => (
  <section id="contact" className="relative py-24 sm:py-32" data-testid="contact-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow index="09">Contact</Eyebrow>
        <h2 className="mt-6 font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl">Book a free <span className="text-outline">business</span> consultation.</h2>
        <p className="mt-6 max-w-md text-slate-300">Tell us about your business and what you need. We'll call you back to understand your requirements — the first consultation is free.</p>
        <ConsultNotice className="mt-8" testId="contact-consult-notice" />
        <div className="mt-10"><ContactDetails /></div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <ConsultForm preset={preset} />
      </Reveal>
    </div>
  </section>
);
